import { OrderDirection } from '@enums/index';

export interface DomainResponse {
    domain: Domain[];
    count: number;
    domainArray: { value: string; key: string }[];
}
export interface Domain {
    id: string;
    createdAt: Date;
    icon: string;
    iconPack: string;
    updatedAt: Date;
    name: string;
}

export interface InterestsResponse {
    interests: Interest[];
    count: number;
    interestsArray: string[];
}
export interface Interest {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    name: string;
}

export interface HobbiesResponse {
    hobbies: Hobby[];
    count: number;
    hobbiesArray: string[];
}
export interface Hobby {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    name: string;
}

export interface SkillsResponse {
    skills: Skill[];
    count: number;
    skillsArray: string[];
}
export interface Skill {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    name: string;
}

export enum SkillType {
    DOMAIN_SPECIFIC = 'DOMAIN_SPECIFIC',
    MENTORSHIP_SPECIFIC = 'MENTORSHIP_SPECIFIC',
}

export interface SkillFilters {
    offset: number;
    limit: number;
    orderDirection?: OrderDirection;
    search?: string;
    orderBy?: string;
    filterByActiveMentorUsage?: boolean;
    domainIds?: string[];
    type?: SkillType;
}

export interface Service {
    id: string;
    createdAt: string;
    updatedAt: string;
    type: string;
}
export interface ServicesResponse {
    services: Service[];
    servicesArray: { value: string; key: string }[];
    count: number;
}

export type DateFilterProps = {
    fromLabel?: string;
    toLabel?: string;
    setFrom: React.Dispatch<React.SetStateAction<string>>;
    setTo: React.Dispatch<React.SetStateAction<string>>;
    from: string;
    to: string;
    minFrom?: string;
    maxFrom?: string;
    width?: number;
};

export type CustomDateInputProps = {
    value: any;
    placeholder: string;
    onChange: any;
    min?: string;
    max?: string;
    disabled?: boolean;
    width: number;
};
